import { render, staticRenderFns } from "./DocumentsEditFormSidebar.vue?vue&type=template&id=dcb87b6e&scoped=true"
import script from "./DocumentsEditFormSidebar.vue?vue&type=script&lang=js"
export * from "./DocumentsEditFormSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcb87b6e",
  null
  
)

export default component.exports